import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { isBefore } from 'date-fns';
import { my_AllElemConsiglioAmministrazioneHelper, my_CalcObbOrganoContrHelper, my_CkScadenzaOrgAmmHelper } from '../../warnings/amm-controllo-common-warnings';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';

@Injectable()
export class NormeSpaOrdinarioWarningService {
    constructor(private store: Store<Revisione53State>) {}

    my_CalcObbOrganoContr = createWarning(this.store, (myVerbale) => {
        return my_CalcObbOrganoContrHelper(myVerbale, CkNormeValuesEnum.normeSpaOrdinario);
    });

    my_CkSpoTipoAmministrazione = createWarning(this.store, (myVerbale) => {
        const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;
        const my_CkSpoTipoAmministrazione = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione;
        const date = new Date(my_DataRevisioneDal);
        const dateBefore = isBefore(date, new Date('01-01-2018'));

        if (!(my_CkSpoTipoAmministrazione != '2' || dateBefore)) {
            return "Attenzione : per le modifiche introdotte dalla legge di bilancio 2018, l'amministrazione della cooperativa non può essere affidata ad un amministratore unico";
        } else {
            return null;
        }
    });

    my_CkScadenzaOrgAmm = createWarning(this.store, (myVerbale) => {
        return my_CkScadenzaOrgAmmHelper(myVerbale, CkNormeValuesEnum.normeSpaOrdinario);
    });

    my_AllElemConsiglioAmministrazione = createWarning(this.store, (myVerbale) => {
        return my_AllElemConsiglioAmministrazioneHelper(myVerbale, CkNormeValuesEnum.normeSpaOrdinario);
    });

    // XSL dead code: in SPO context CkNorme === '2' is always true, so this warning is always suppressed — intentional alignment.
    my_AllElemCollegioSindacale = createWarning(this.store, (myVerbale) => {
        const my_AllElemCollegioSindacale = myVerbale?.my_SezioneI__Rilevazione?.my_AmministrazioneControllo?.my_AllCollegioSindacale?.my_AllElemCollegioSindacale;
        const my_CkNorme = myVerbale?.my_SezioneI__Rilevazione?.my_AmministrazioneControllo?.my_CkNorme;
        if (!(my_CkNorme === CkNormeValuesEnum.normeSpaOrdinario.toString() || my_AllElemCollegioSindacale?.length >= 3)) {
            return 'Attenzione: Il collegio sindacale non può avere meno di 3 componenti';
        } else {
            return null;
        }
    });
}
